/* eslint-disable */
import Api from '@/repository/index'
import moment from 'moment'
import globalMixin from '@/mixin/global'
import { showDefaultErrorMessage, errorResponseMessage } from '@/utils/createMessage'
import { Message } from 'element-ui'

const { getUtcFromDate, getRootStaticUrl } = globalMixin.methods;
export const SET_FINE_TYPE_NOT_FIND = 'SET_FINE_TYPE_NOT_FIND'
export const SET_FINE_TYPE_FIND = 'SET_FINE_TYPE_FIND'
export const SET_FINE_TYPE_NOT_HOLD = 'SET_FINE_TYPE_NOT_HOLD'
export const SET_FINE_TYPE_COMPLETE = 'SET_FINE_TYPE_COMPLETE'
export const NOT_FIND_MOVE_TO_FIND_BY_ID = 'NOT_FIND_MOVE_TO_FIND_BY_ID'

export const TOOGLE_DESCRIPTION_DIALOG = 'TOOGLE_DESCRIPTION_DIALOG'
export const SET_DESCRIPTION_DIALOG = 'SET_DESCRIPTION_DIALOG'

export const ADD_INFORMATION_DRIVER_TO_FINE = 'ADD_INFORMATION_DRIVER_TO_FINE'
export const ADD_INFORMATION_DRIVER_TO_FINE_FIND = 'ADD_INFORMATION_DRIVER_TO_FINE_FIND'

export const FIND_MOVE_TO_NOT_HOLD = 'FIND_MOVE_TO_NOT_HOLD'
export const FIND_MOVE_TO_NOT_HOLD_ALL = 'FIND_MOVE_TO_NOT_HOLD_ALL'
export const NOT_HOLD_MOVE_TO_COMPLETE = 'NOT_HOLD_MOVE_TO_COMPLETE'

export const TOOGLE_LOADING_NOT_FIND = 'TOOGLE_LOADING_NOT_FIND'
export const TOOGLE_LOADING_FIND = 'TOOGLE_LOADING_FIND'
export const TOOGLE_LOADING_NOT_HOLD = 'TOOGLE_LOADING_NOT_HOLD'
export const TOOGLE_LOADING_COMPLETE = 'TOOGLE_LOADING_COMPLETE'

export const TOOGLE_LOADING = 'TOOGLE_LOADING'

export const SET_FILTERS = 'SET_FILTERS'

export const TOOGLE_SELECT_DRIVER_DIALOG = 'TOOGLE_SELECT_DRIVER_DIALOG'
export const SET_SELECT_DRIVER_ID_DIALOG_TEMP = 'SET_SELECT_DRIVER_ID_DIALOG_TEMP'
export const TOOGLE_IS_COMPANY_PROFIT_NOT_HOLD = 'TOOGLE_IS_COMPANY_PROFIT_NOT_HOLD'

const state = {
  fineTypeNotFind: [],
  fineTypeFind: [],
  fineTypeNotHold: [],
  fineTypeComplete: [],
  filters: {
    car_number: null,
    driverID: null,
    dateTime: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  },
  isLoading: true,

  isLoadingNotFind: true,
  isLoadingFind: true,
  isLoadingNotHold: true,
  isLoadingComplete: true,

  descriptionDialogData: [],
  descriptionDialogVisible: false,

  changeDriverDialog: false,
  changeDriverDialogTempId: {
    id: null,
    type: 'NotFind'
  }
}
const utils = {
  getValidRequestDate (date) {
    const [start_date, end_date] = date
    return {
      startDate: getUtcFromDate(start_date),
      endDate: getUtcFromDate(end_date)
    }
  },
  filtredFines (filter, fine) {
    const { driverID, car_number } = filter
    // if (!driverID && !car_number) return false
    let returnFilters = fine
    if (driverID) {
      returnFilters = returnFilters.filter(elem => elem.driverId === driverID)
    }
    if (car_number) {
      returnFilters = returnFilters.filter(elem => elem.carNumber === car_number)
    }
    return returnFilters
  }
}
const mutations = {
  [SET_FINE_TYPE_NOT_FIND]: (state, data) => {
    state.fineTypeNotFind = data
  },
  [SET_FINE_TYPE_FIND]: (state, data) => {
    state.fineTypeFind = data
  },
  [SET_FINE_TYPE_NOT_HOLD]: (state, data) => {
    state.fineTypeNotHold = data
  },
  [SET_FINE_TYPE_COMPLETE]: (state, data) => {
    state.fineTypeComplete = data
  },

  [TOOGLE_LOADING] (state, value) {
    state.isLoading = value
  },

  [TOOGLE_LOADING_NOT_FIND] (state, value) {
    state.isLoadingNotFind = value
  },
  [TOOGLE_LOADING_FIND] (state, value) {
    state.isLoadingFind = value
  },
  [TOOGLE_LOADING_NOT_HOLD] (state, value) {
    state.isLoadingNotHold = value
  },
  [TOOGLE_LOADING_COMPLETE] (state, value) {
    state.isLoadingComplete = value
  },

  [SET_FILTERS] (state, value) {
    state.filters = value
  },

  [SET_DESCRIPTION_DIALOG] (state, value) {
    state.descriptionDialogData = value
  },
  [TOOGLE_DESCRIPTION_DIALOG] (state, value) {
    state.descriptionDialogVisible = value
  },
  [TOOGLE_SELECT_DRIVER_DIALOG] (state, value) {
    state.changeDriverDialog = value
  },
  [SET_SELECT_DRIVER_ID_DIALOG_TEMP] (state, { id, type }) {
    state.changeDriverDialogTempId = {
      id, type
    }
  },

  [NOT_FIND_MOVE_TO_FIND_BY_ID] (state, id) {
    const getIndexNotFindById = state.fineTypeNotFind.findIndex(item => item.id === id)
    state.fineTypeFind.unshift(state.fineTypeNotFind[getIndexNotFindById])
    state.fineTypeNotFind.splice(getIndexNotFindById, 1)
  },
  [FIND_MOVE_TO_NOT_HOLD] (state, { id, file }) {
    const getIndexNotFindById = state.fineTypeFind.findIndex(item => item.id === id)
    state.fineTypeNotHold.unshift({ ...state.fineTypeFind[getIndexNotFindById], file })
    state.fineTypeFind.splice(getIndexNotFindById, 1)
  },
  [FIND_MOVE_TO_NOT_HOLD_ALL] (state, { fine_ids, file }) {
    console.log(fine_ids, 'почему')
    fine_ids.forEach(id => {
      console.log(id, 'ну запара')
      const getIndexNotFindById = state.fineTypeFind.findIndex(item => item.id === id)
      state.fineTypeNotHold.unshift({ ...state.fineTypeFind[getIndexNotFindById], file })
      state.fineTypeFind.splice(getIndexNotFindById, 1)
    })
  },
  [TOOGLE_IS_COMPANY_PROFIT_NOT_HOLD] (state, id) {
    const getIndexById = state.fineTypeNotHold.findIndex(item => item.id === id)
    state.fineTypeNotHold[getIndexById].isCompanyPayment = !state.fineTypeNotHold[getIndexById].isCompanyPayment
    if (state.fineTypeNotHold[getIndexById].isCompanyPayment) {
      state.fineTypeNotHold = [...state.fineTypeNotHold.filter((x, inx) => inx !== getIndexById)]
    }
  },
  [NOT_HOLD_MOVE_TO_COMPLETE] (state, id) {
    const getIndexNotFindById = state.fineTypeNotHold.findIndex(item => item.id === id)
    if (getIndexNotFindById === -1) return
    state.fineTypeComplete.unshift(state.fineTypeNotHold[getIndexNotFindById])
    state.fineTypeNotHold.splice(getIndexNotFindById, 1)
  },
  [ADD_INFORMATION_DRIVER_TO_FINE] (state, { id, driver_id }) {
    const getIndexNotFindById = state.fineTypeNotFind.findIndex(item => item.id === id)
    if (getIndexNotFindById === -1) return
    state.fineTypeNotFind[getIndexNotFindById].driverId = driver_id
    state.fineTypeNotFind[getIndexNotFindById].custom_id = true
  },
  [ADD_INFORMATION_DRIVER_TO_FINE_FIND] (state, { id, driver_id }) {
    const getIndexFindById = state.fineTypeFind.findIndex(item => item.id === id)
    if (getIndexFindById === -1) return
    state.fineTypeFind[getIndexFindById].driverId = driver_id
    state.fineTypeFind[getIndexFindById].custom_id = true
  }
}

const getters = {
  getAllDrivers: (state) => {
    const mergeAllTypesFines = [...state.fineTypeNotFind, ...state.fineTypeFind, ...state.fineTypeNotHold, ...state.fineTypeComplete]
    const mergedTypesFiltred = mergeAllTypesFines.filter((x) => !!~~x.driverId)
    const mergedTypesMaped = mergedTypesFiltred.map(val => {
      return { driverId: val.driverId, driverName: val.driverName }
    })
    return [...new Set(mergedTypesMaped)]
  },
  getAllCars: (state) => {
    const mergeAllTypesFines = [...state.fineTypeNotFind, ...state.fineTypeFind, ...state.fineTypeNotHold, ...state.fineTypeComplete]
    const mergedTypesFiltred = mergeAllTypesFines.filter((x) => !!x.carNumber)
    const mergedTypesMaped = mergedTypesFiltred.map(val => val.carNumber)
    return [...new Set(mergedTypesMaped)]
  },

  sortedDataByFilterNotFind (state) {
    return utils.filtredFines(state.filters, state.fineTypeNotFind)
  },
  sortedDataByFilterFind (state) {
    return utils.filtredFines(state.filters, state.fineTypeFind)
  },
  sortedDataByFilterNotHold (state) {
    return utils.filtredFines(state.filters, state.fineTypeNotHold)
  },
  sortedDataByFilterComplete (state) {
    return utils.filtredFines(state.filters, state.fineTypeComplete)
  },

  getCurrentDriversOnThePark: (state, getters, rootState) => {
    if (!rootState?.schedule?.currentRegionParkID) return getters.sortedDataByFilter
    return getters.sortedDataByFilter.filter(driver => driver.regionParkId === rootState?.schedule?.currentRegionParkID)
  }
}
const actions = {
  async getFinesByTypeNotFind ({ commit, state }) {
    try {
      commit('TOOGLE_LOADING_NOT_FIND', true)
      const response = await Api.tenants.fines.getFines({
        fineType: 'not_find',
        ...utils.getValidRequestDate(state.filters.dateTime)
      })
      commit('TOOGLE_LOADING_NOT_FIND', false)

      commit('SET_FINE_TYPE_NOT_FIND', response)
    } catch (e) {
      showDefaultErrorMessage()
      return Promise.reject(e)
    }
  },
  async getFinesByTypeFind ({ commit, state }) {
    try {
      commit('TOOGLE_LOADING_FIND', true)
      const response = await Api.tenants.fines.getFines({
        fineType: 'find',
        ...utils.getValidRequestDate(state.filters.dateTime)
      })
      commit('TOOGLE_LOADING_FIND', false)

      commit('SET_FINE_TYPE_FIND', response)
    } catch (e) {
      showDefaultErrorMessage()
      return Promise.reject(e)
    }
  },
  async deleteFine ({ commit, state, dispatch }, { dta, fineId }) {
    try {
      await Api.tenants.fines.deleteFine({
        fineId
      })
      const { newStatus, unpaidStatus, unrecognizedStatus } = dta
      if (newStatus) {
        await dispatch('getFinesByTypeFind')
      }
      if (unpaidStatus) {
        await dispatch('getFinesByTypeNotHold')
      }
      if (unrecognizedStatus) {
        await dispatch('getFinesByTypeNotFind')
      }
      Message({
        type: 'success',
        message: 'Успешно!'
      })
    } catch (e) {
      await errorResponseMessage(e.response.data)
      return Promise.reject(e)
    }
  },
  async getFinesByTypeNotHold ({ commit, state }) {
    try {
      commit('TOOGLE_LOADING_NOT_HOLD', true)

      const response = await Api.tenants.fines.getFines({
        fineType: 'not_hold',
        ...utils.getValidRequestDate(state.filters.dateTime)
      })
      commit('TOOGLE_LOADING_NOT_HOLD', false)

      commit('SET_FINE_TYPE_NOT_HOLD', response)
    } catch (e) {
      showDefaultErrorMessage()
      return Promise.reject(e)
    }
  },
  async getFinesByTypeComplete ({ commit, state }) {
    try {
      commit('TOOGLE_LOADING_COMPLETE', true)

      const response = await Api.tenants.fines.getFines({
        fineType: 'complete',
        ...utils.getValidRequestDate(state.filters.dateTime)
      })
      commit('TOOGLE_LOADING_COMPLETE', false)

      commit('SET_FINE_TYPE_COMPLETE', response)
    } catch (e) {
      showDefaultErrorMessage()
      return Promise.reject(e)
    }
  },

  async acceptFineById ({ commit, state }, { id, driver_id }) {
    try {
      await Api.tenants.fines.acceptToFindFine({
        fineId: id
      })
      commit('NOT_FIND_MOVE_TO_FIND_BY_ID', id)
      Message({
        type: 'success',
        message: 'Штраф успешно принят'
      })
    } catch (e) {
      await errorResponseMessage(e.response.data)
      return Promise.reject(e)
    }
  },
  async driverBinding ({ commit, state, dispatch }, { fineId, driverId }) {
    try {
      await Api.tenants.fines.changeDriver({ fineId, driverId })
      // commit('ADD_INFORMATION_DRIVER_TO_FINE', { id: fineId, driver_id: driverId })
      dispatch('getFinesByTypeNotHold')
      dispatch('getFinesByTypeNotFind')
      dispatch('getFinesByTypeFind')
      Message({
        type: 'success',
        message: 'Водитель успешно изменен'
      })
    } catch (e) {
      await errorResponseMessage(e.response.data)
      return Promise.reject(e)
    }
  },
  async driverBindingFind ({ commit, state, dispatch }, { fineId, driverId }) {
    try {
      await Api.tenants.fines.changeDriver({ fineId, driverId })
      await dispatch('getFinesByTypeFind')
      // commit('ADD_INFORMATION_DRIVER_TO_FINE_FIND', { id: fineId, driver_id: driverId })
      Message({
        type: 'success',
        message: 'Водитель успешно изменен'
      })
    } catch (e) {
      await errorResponseMessage(e.response.data)
      return Promise.reject(e)
    }
  },
  async changeStatusFineFind ({ commit, state }, id) {
    try {
      // debugger

      const { file } = await Api.tenants.fines.acceptFine({
        fineId: [id]
      })

      commit('FIND_MOVE_TO_NOT_HOLD', { id, file })
      if (!file) return
      window.open(getRootStaticUrl(file))
    } catch (e) {
      const msg = e?.response?.data?.message
      Message({
        type: 'error',
        message: msg
      })
      return Promise.reject(e)
    }
  },
  async changeStatusFineAll ({ commit, state }, { fine_ids }) {
    try {
      const { file } = await Api.tenants.fines.acceptFine({
        fineId: fine_ids
      })

      commit('FIND_MOVE_TO_NOT_HOLD_ALL', { fine_ids })
      if (!file) return
      window.open(getRootStaticUrl(file))
    } catch (err) {

    }
  },
  async changeStatusFineNotHold ({ commit, state }, data) {
    try {
      if (!data?.file) {
        return Message({
          type: 'error',
          message: 'Файл не найден!'
        })
      }
      window.open(getRootStaticUrl(data?.file))
      // await changeStatusFine({ fine_id: id })
      // commit('NOT_HOLD_MOVE_TO_COMPLETE', id)
      // Message({
      //   type: 'success',
      //   message: 'В разработке'
      // })
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async setFilters ({ commit }, val) {
    try {
      commit('SET_FILTERS', val)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async toogleDescriptionDialog ({ commit }, val) {
    try {
      commit('TOOGLE_DESCRIPTION_DIALOG', val)
      if (!val) commit('SET_DESCRIPTION_DIALOG', [])
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async toogleCheckboxCompanyPayed ({ commit }, { fine_id, is_payed }) {
    try {
      await Api.tenants.fines.changeCompanyPayment({
        fineId: fine_id, isPayed: is_payed
      })
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async toogleSelectDriverDialog ({ commit }, val) {
    try {
      commit('TOOGLE_SELECT_DRIVER_DIALOG', val)
      if (!val) return commit('SET_SELECT_DRIVER_ID_DIALOG_TEMP', { id: null, type: null })
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async setTempIdDialogSelectDriver ({ commit }, { id, type }) {
    commit('SET_SELECT_DRIVER_ID_DIALOG_TEMP', { id, type })
  },
  async getFineByIdAndToogleDialog ({ commit, state }, id) {
    try {
      const data = await Api.tenants.fines.getFineById({ fineId: id })
      commit('SET_DESCRIPTION_DIALOG', data)
      commit('TOOGLE_DESCRIPTION_DIALOG', true)
    } catch (e) {
      return Promise.reject(e)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
